export const UserRole = {
	projectAdmin: 'projectAdmin',
	jiraAdmin: 'jiraAdmin',
	siteAdmin: 'siteAdmin',
} as const;
